import { ApiResult, post } from '@/utils/api';
import { ScanPaymentResp } from '@/model/payment';

export const scanPayment = (data: any): Promise<ApiResult<ScanPaymentResp>> =>
  post<ScanPaymentResp>('/scan/scanPayment', data);

export const refreshScanPayment = (data: any): Promise<ApiResult<ScanPaymentResp>> =>
  post<ScanPaymentResp>('/scan/refreshScanPayment', data);
